/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
import React from "react";
import CustomTooltip from "../../../../../../../../components/CustomTooltip";
import {EmailSubsectionChip, MobileIcon} from "../../../../../../../../components/buttons/IconButtons";
import {EMPTY_VALUES} from "../../../../../../../../Apis/functions";

/**
 * People a folio is followed by.
 *
 * A folio is watched by as many people as it was registered with, so the
 * section reads the list it receives and grows with it, and the rows that only
 * name one person keep sending it as a single contact.
 *
 * @param {Function} t - Translation function.
 * @param {string} title - Title of the section.
 * @param {string} name - Name of the single contact.
 * @param {string} email - Email of the single contact.
 * @param {string} phoneNumber - Phone number of the single contact.
 * @param {Array<Object>} contacts - People read by the section, when it has more than one.
 *
 * @returns {JSX.Element} Section of the people of a folio.
 */
const ContactSection = ({t, title, name, email, phoneNumber, contacts = null}) => {
    const list = contacts?.length > 0 ? contacts : [{name, email, phoneNumber}];

    return (
        <div className={'col-12 px-0'}>
            <p className='font-color-general-950 fs-14px ibl-font-w-600 px-0 mb-1'>
                {t(title)}
            </p>

            {list.map((contact, index) => (
                <div key={`${index}-${contact?.email}`} className={index > 0 ? 'mt-2' : ''}>
                    <p className='font-color-general-950 fs-14px ibl-font-w-400 px-0 mb-1'>
                        {contact?.name}
                    </p>

                    <div className={'d-flex justify-content-between p-0 gap-3'}>
                        <div className={'d-flex flex-grow-1 minw-0 align-items-center'}>
                            <div className={'mr-2 d-flex align-items-center'}>
                                <EmailSubsectionChip/>
                            </div>
                            <div className={'flex-grow-1 minw-0'}>
                                <CustomTooltip
                                    text={contact?.email}
                                    classes={'fs-14px font-color-general-950 text-ellipsis-1-row align-items-center'}
                                    showIfTruncated={true}
                                />
                            </div>
                        </div>

                        <div className={'d-flex flex-grow-1 minw-0'}>
                            <div className={'mr-2 d-flex align-items-center'}>
                                <MobileIcon className={'icon-color-shades-800 flex-shrink-0'}/>
                            </div>
                            <div className={'flex-grow-1 minw-0'}>
                                <CustomTooltip
                                    text={contact?.phoneNumber || EMPTY_VALUES.DEFAULT}
                                    classes={'fs-14px font-color-general-950 text-ellipsis-1-row'}
                                    showIfTruncated={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ContactSection;
